import type { FlagSet } from '@sorare/core/src/contexts/featureFlags/index.ts';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags.tsx';

// Absent from FeatureFlagKey until enable-public-squads gets "SDK using Client-side ID" in LaunchDarkly
type PublicSquadsFlags = FlagSet & { enablePublicSquads?: boolean };

export const useEnablePublicSquads = () => {
  const {
    flags: { enablePublicSquads = false },
  } = useFeatureFlags<PublicSquadsFlags>();

  return enablePublicSquads;
};
